import { render } from "./OverviewBox.vue?vue&type=template&id=94dcc0ac&scoped=true&ts=true"
import script from "./OverviewBox.vue?vue&type=script&lang=ts"
export * from "./OverviewBox.vue?vue&type=script&lang=ts"

import "./OverviewBox.vue?vue&type=style&index=0&id=94dcc0ac&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94dcc0ac"]])

export default __exports__